var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-container flex-column"},[(_vm.viewList.length)?_c('top-top',{attrs:{"list":_vm.viewList,"pageStyle":_vm.pageStyle}}):_vm._e(),_vm._v(" "),(_vm.navData.list && _vm.navData.list.length)?_c('top-nav',{attrs:{"websiteId":_vm.website_id,"data":_vm.navData}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30d93d88","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layout/top.vue
// module id = null
// module chunks = 